import axios from "../http";

let module = "/school";

function getSchoolSelect() {
    return axios.get(module+"/allSchool");
}

function getSchoolList(data) {
    return axios.post(module+"/school",data);
}

function deleteSchool(id) {
    return axios.delete(module+"/"+id);
}

function addSchool(data) {
    return axios.post(module,data);
}

function updateSchool(data) {
    return axios.put(module, data);
}

function geAlumni(data) {
    return axios.post(module+"/"+data.id+"/students",data);
}

export default {
    getSchoolSelect,getSchoolList,deleteSchool,addSchool,updateSchool,geAlumni
}
